import {SiteStructure} from '@wix/native-components-infra/dist/src/types/types'
import {BreadcrumbsItem} from 'wix-ui-tpa/dist/cssVars/types/components'
import {ControllerFlowAPI} from '@wix/yoshi-flow-editor'

import {AppPage} from './constants'

export const getBreadcrumbsConfig = (
  flowAPI: ControllerFlowAPI,
  siteStructure: SiteStructure,
  parentPage: AppPage,
  currentPageName?: string,
) => {
  const {baseUrl} = flowAPI.controllerConfig.wixCodeApi.location
  const {pages: sitePages} = siteStructure
  const {t} = flowAPI.translations

  const homePage = {
    name: t('uou-reservations.reservations.breadcrumbs-homepage-label'),
    url: '/',
  }
  const currentPageId = flowAPI.controllerConfig.wixCodeApi.site.currentPage?.id
  const currentPage = sitePages.find((page) => page.id === currentPageId)!

  const homePageCrumb = {
    id: '1',
    value: homePage.name,
    href: `${baseUrl}${homePage.url}`,
  }

  if (
    // @ts-expect-error
    currentPage?.tpaPageId === AppPage.Reservations ||
    // @ts-expect-error
    currentPage?.tpaPageId === AppPage.ExperiencesList
  ) {
    return [
      homePageCrumb,
      {
        id: '2',
        value: currentPageName ?? currentPage.name,
        href: `${baseUrl}${currentPage.url}`,
      },
    ]
  }

  // @ts-expect-error
  const parentPageConfig = sitePages.find((page) => page.tpaPageId === parentPage) || {
    name: parentPage,
    url: '',
  }

  return [
    homePageCrumb,
    {
      id: '2',
      value: parentPageConfig.name,
      href: `${baseUrl}${parentPageConfig.url}`,
    },
    {
      id: '3',
      value: currentPageName ?? currentPage?.name,
      href: `${baseUrl}${currentPage?.url}`,
    },
  ]
}

export const generateBreadcrumbsSD = (breadcrumbs: BreadcrumbsItem[]) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((breadcrumb) => ({
      '@type': 'ListItem',
      name: breadcrumb.value,
      item: breadcrumb.href,
    })),
  }
}
